  <template>
    <select class="form-control control-lg" v-model="selected" v-bind:id="'select_' +  getId()">
      <slot></slot>
    </select>
  </template>

<script>

	export default {
    name: 'input-select',
		components: {
    },
    data() {
      return {
      };
    },
    props: [
      'placeholder',
      'selected'
    ],
    methods: {
      onChange() {
        this.$emit('change', $("#" + 'select_' + this.getId()).val());
      },
      input(event) {
        this.value = event.target.value;
        this.$emit('input', event.target.value);
      },
      getId() {
        return this._uid;
      },
    },
    created() {
      
    },
    mounted() {
     
    }
}
</script>



// WEBPACK FOOTER //
// src/components/form-components/input-select.vue